<script setup lang="ts">
  import { useUserStore } from '@/stores/user'
  import { onMounted } from 'vue'
  import Screencastomatic from '@/helpers/screencastomatic'

  const user = useUserStore()

  onMounted(() => Screencastomatic.setupScreencastomaticScript(user.user))
</script>

<template>
  <div class="fixed -top-4 right-4 max-w-0 hidden md:block">
    <div id="screencastomatic-target" class="absolute opacity-0 w-0 h-0"></div>
  </div>
</template>

<style>
  #som_record_button_cqeIeclY {
    max-width: 0 !important;
    padding: 0 !important;
    overflow: hidden;
  }

  .opentip-container {
    position: fixed !important;
  }
</style>
